
import { api_post } from "./utils";

const PresenceAPI = {
    set: _setPresence,
}

async function _setPresence(identityKey: string) {
    if (!identityKey) {
        throw "Identity key is required"
    }
    return api_post('/presence/set', { identity: identityKey})
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
            else {
                throw "Unable to update presence"
            }
        });

}

export default PresenceAPI;
